<template lang="html">
  <div class="invite-settings">
    <div class="section-header">
      <h2>Invite</h2>
    </div>

    <p>Copy any of these and send them out to your league members.</p>

    <div class="setting">
      <label>Invite text</label>

      <div class="value">
        <span v-html="inviteText" />

        <button
          class="copy small hollow"
          v-clipboard:copy="inviteText"
          v-clipboard:success="copy"
        >
          <i class="fas fa-copy"></i>
        </button>
      </div>
    </div>

    <div class="setting">
      <label>Invite code</label>

      <div class="value">
        {{ draft.code }}
        <button
          class="copy small hollow"
          v-clipboard:copy="draft.code"
          v-clipboard:success="copy"
        >
          <i class="fas fa-copy"></i>
        </button>
      </div>
    </div>

    <div class="setting">
      <label>Invite url</label>

      <div class="value">
        {{ inviteUrl }}
        <button
          class="copy small hollow"
          v-clipboard:copy="inviteUrl"
          v-clipboard:success="copy"
        >
          <i class="fas fa-copy"></i>
        </button>
      </div>
    </div>

    <app-icons />
  </div>
</template>

<script>
import { mapState } from 'vuex';

import AppIcons from '@/components/AppIcons';

export default {
  components: {
    AppIcons,
  },

  computed: {
    ...mapState({
      draft: ({ draft }) => draft.draft,
    }),

    inviteText() {
      return `Ready for another fantasy football season? This year we're going to do an in-person draft with 1st&5. To get started download the app and punch in the invite code after you sign up. \n\n iOS: https://apple.co/2N3oZjU \n\nAndroid: shorturl.at/qEK04 \n\nCode: ${this.draft.code}`;
    },

    inviteUrl() {
      return `${process.env.VUE_APP_APP_URL}/invite?code=${this.draft.code}`;
    },
  },

  methods: {
    copy() {
      this.$toast({ message: 'Copied to your clipboard!' });
    },
  },
};
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
  @import "./settings";

  .invite-settings {
    @include settingSection;
  }

  .copy {
    margin-left: $gp;
  }
</style>
